<div class="ui-unset-flex">
  <div class="mct-flex mct-row mct-gap-80"  >
    <div class="mct-flex mct-col" >
      <div class="field-column">
        <div>
          <label>{{ 'invoices.invoice-builder.payment-tab.credit-card' | translate | titlecase }}</label>
          <p-select
            placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
            [style]="{ width: '100%' }"
            [options]="cardTypes"
            [(ngModel)]="creditCardPayment.CardType"
          ></p-select>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.credit-card-number' | translate | titlecase }}</label>
          <input [(ngModel)]="creditCardPayment.CardNum" type="number" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.pin-secret-code' | translate }}</label>
          <input [(ngModel)]="creditCardPayment.SecurityCode" type="number" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.valid-through' | translate | titlecase }}</label>
          <div class="mct-flex mct-row mct-gap-6"  >
            <p-select
              placeholder="{{ 'invoices.invoice-builder.payment-tab.month' | translate | titlecase }}"
              [(ngModel)]="creditCardPayment.ValidThruMonth"
              [style]="{ width: '100%' }"
              [options]="months"
            ></p-select>
            <p-select
              placeholder="{{ 'invoices.invoice-builder.payment-tab.year' | translate | titlecase }}"
              [(ngModel)]="creditCardPayment.ValidThruYear"
              [style]="{ width: '100%' }"
              [options]="years"
            ></p-select>
          </div>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.name-on-card' | translate | titlecase }}</label>
          <input [(ngModel)]="creditCardPayment.CreditCardContactInfo.NameOnCard" />
        </div>
      </div>
    </div>
    <div class="field-column">
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.address' | translate | titlecase }}</label>
        <input [(ngModel)]="creditCardPayment.CreditCardContactInfo.Address1" type="text" />
        <input class="mt-5" [(ngModel)]="creditCardPayment.CreditCardContactInfo.Address2" type="text" />
      </div>
      <div class="mct-flex mct-row mct-gap-6"  >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.city' | translate | titlecase }}</label>
          <input type="text" [(ngModel)]="creditCardPayment.CreditCardContactInfo.City" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.state' | translate | titlecase }}</label>
          <wl-state-selector [displayAbbreviation]="true" [(ngModel)]="creditCardPayment.CreditCardContactInfo.State"></wl-state-selector>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.zip' | translate | titlecase }}</label>
          <input type="text" [(ngModel)]="creditCardPayment.CreditCardContactInfo.Zip" />
        </div>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.country' | translate | titlecase }}</label>
        <input type="text" [(ngModel)]="creditCardPayment.CreditCardContactInfo.Country" />
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.phone-number' | translate | titlecase }}</label>
        <input type="text" [(ngModel)]="creditCardPayment.CreditCardContactInfo.Phone" />
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.email-address' | translate | titlecase }}</label>
        <input type="text" [(ngModel)]="creditCardPayment.CreditCardContactInfo.Email" />
      </div>
    </div>
  </div>
</div>
